import { useMutation, useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const usePublicPaymentPayPal = (parent_id, parent_type) => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/public_payments`,
        method: "post",
        body: { parent_id: parent_id, parent_type: parent_type, method: "paypal" },
      }),
  });
};

export const useCompletePublicPaymentPayPal = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/public_payments`,
        method: "put",
        body: data,
      }),
  });
};

export const usePublicPayments = (id, hash, config) => {
  return useQuery({
    ...config,
    queryKey: ["payments", id],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/public_payments/back-url?number=${id}&hash=${hash}`,
      }),
  });
};

export const usePublicPaymentStripe = () => {
  return useMutation({
    mutationFn: ({ parent_id, parent_type, token }) =>
      fetch({
        url: `${Angie.api_url}/public_payments`,
        method: "post",
        body: { parent_id: parent_id, parent_type: parent_type, token: token.id, method: "credit_card" },
      }),
  });
};

export const usePublicPaymentStripe3dsProcessing = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/public-payments/process-stripe-confirmation-intent`,
        method: "post",
        body: { payment_intent_id: data.payment_intent_id },
      }),
  });
};
